import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import moment from 'moment';
import {useSelector} from 'react-redux';
import ToggleDropdown from '../../ToogleDropdown';
import Active from '../../../SVG/Active';
import Pencil from '../../../SVG/Pencil';
import Trash from '../../../SVG/Trash';
import Blocked from '../../../SVG/Blocked';
import DecomissionReason from '../../../SVG/DecomissionReason';
import { useTranslation } from '../../../hooks/useTranslation';
import Archive from '../../../SVG/Archive';
import UnAssignModal from '../../../pages/EquipmentManagement/components/UnAssignModal/UnAssignModal';

const ToolsRow = ({
  tool,
  setCurrentTool,
  currentTab,
  currentTool,
  setConfirmModal,
  setCurrentId,
  activate,
  getToolsDecom,
  setDeleteModal,
  setArchiveModal,
  setActivateModal,
  currentId
}) => {
  const {t} = useTranslation();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const [dropdownStatus, setDropdownStatus] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [unAssignStatus, setUnAssignStatus] = useState(false);

  useEffect(() => {
    return window.addEventListener('click', e => {
      if (
        e.target.closest('.tools__table-action') === null &&
        e.target.closest('.tools__table-dropdown') === null
      ) {
        setDropdownStatus(false);
      }
    });
  }, [location]);

  const handleUnAssign = (tool) => {
    setUnAssignStatus(true);
    setCurrentId(tool?.id);
  };

  const handleDelete = (tool) => {
    setDeleteModal(true);
    setCurrentTool(tool);
  };

  return (
    <React.Fragment key={tool?.id}>
      <div
        className={`tools__table-row ${currentTab == 1 || currentTab == 4 ? 'tool' : currentTab == 2 || currentTab == 3 ? 'calibration' : ''} ${currentTab == 6 ? 'archived' : ''}`}
        style={{
          borderBottom: currentTab == 4 && tool?.decommission_reason ? 'none' : '',
        }}
        onClick={() => {
          if (currentTab == 2 || currentTab == 3) {
            navigate(`/inspections/${tool.inspection_id}`);
          }
        }}
      >
        {currentTab == 1 || currentTab == 4 ? (
          <>
            <div
              className='tools__table-bodyTh'
              style={{
                paddingBottom: tool?.decommission_reason ? '0px' : '',
              }}
            >
              <p className='tools__table-subtitle'>{tool?.title}</p>
            </div>
            <div
              className='tools__table-bodyTh'
              style={{
                paddingBottom: tool?.decommission_reason ? '0px' : '',
              }}
            >
              <p className='tools__table-subtitle'>
                {
                  tool?.fields?.filter(el => el.key === 'tool_description')[0]
                    ?.value
                }
              </p>
            </div>
            <div
              className='tools__table-bodyTh'
              style={{
                paddingBottom: tool?.decommission_reason ? '0px' : '',
              }}
            >
              <p className='tools__table-subtitle'>
                {tool?.tool_calibration_period}
              </p>
            </div>
            <div
              className='tools__table-bodyTh'
              style={{
                paddingBottom: tool?.decommission_reason ? '0px' : '',
              }}
            >
              <p className='tools__table-subtitle'>
                {tool?.tool_calibration_date_label}
              </p>
            </div>
            <div
              className='tools__table-bodyTh action'
              style={{
                paddingBottom: tool?.decommission_reason ? '0px' : '',
              }}
            >
              <ToggleDropdown
                index={tool?.id}
                itemId={tool?.id}
                selectedItem={currentId}
                setSelectedItem={setCurrentId}
                showNdxId={userInfo?.is_global}
              >
                <div
                onClick={() => {
                  navigate(`/tools/edit/${tool?.id}`);
                }}
                className='equipment__table-btn s'
              >
                <Pencil color={'#999999'}/>
  {t('toolsRow.actions.edit')}
              </div>
              {!tool?.is_active && userInfo?.is_global && currentTab === 6 && (
                <div
                  onClick={() => {
                    setDeleteModal(true);
                    setCurrentId(tool?.id);
                  }}
                  className='equipment__table-btn red'
                >
                    <Trash color={'#999999'}/>
  {t('toolsRow.actions.delete')}
                </div>
                )}
                {currentTab === 4 && (
                  <div
                    onClick={() => {
                      setArchiveModal(true);
                      setCurrentId(tool?.id);
                    }}
                    className='equipment__table-btn red'
                  >
                    <Archive color={'#999999'} />
                    {t('equipmentTable.actions.archive')}
                  </div>
                )}
              { tool?.is_active ? (
                <div
                  className='equipment__table-btn decom'
                  onClick={() => {
                    setCurrentId(tool?.id);
                    setConfirmModal(true);
                  }}
                  >
                    <Blocked color={'#999999'}/>
  {t('toolsRow.actions.decommission')}
                </div>
              ) : (
                <div
                  className='equipment__table-btn decom green'
                  onClick={() => {
                    activate(tool?.id).then(res => {
                      getToolsDecom();
                    });
                  }}
                    >
                      <Active color={'#999999'}/>
  {t('toolsRow.actions.activate')}
                </div>
              )}
              </ToggleDropdown>
            </div>
          </>
        ) : currentTab == 2 ? (
        <>
          <div className='tools__table-bodyTh'>
            <p className='tools__table-subtitle'>{tool?.equipment_title}</p>
          </div>
          <div className='tools__table-bodyTh'>
            <p className='tools__table-subtitle'>
              {
                tool?.equipment_fields?.filter(
                  el => el.key === 'tool_description',
                )[0]?.value
              }
            </p>
          </div>
          <div className='tools__table-bodyTh'>
            <p className='tools__table-subtitle'>
              {tool?.equipment_fields?.filter(
                el => el.key === 'tool_calibration_period',
              )[0]?.value + ' months'}
            </p>
          </div>
          <div className='tools__table-bodyTh'>
            <p className='tools__table-subtitle'>
              {/*{tool?.submitted_user?.length > 0 ? tool?.submitted_user[0]?.name : '---'}*/}
              {tool?.categories[0]?.fields?.filter(
                el => el.label === t('toolsRow.labels.calibratedBy'),
              )?.length > 0
                ? tool?.categories[0]?.fields?.filter(
                    el => el.label === t('toolsRow.labels.calibratedBy'),
                  )[0]?.answers[0]?.length > 0
                  ? tool?.categories[0]?.fields?.filter(
                      el => el.label === t('toolsRow.labels.calibratedBy'),
                    )[0]?.answers[0]
                  : '---'
                : '---'}
            </p>
          </div>
          <div className='tools__table-bodyTh'>
            <p className='tools__table-subtitle'>
              {moment(tool?.calibration_due_date)?.format('MM/DD/YYYY')}
            </p>
          </div>
          <div className='tools__table-bodyTh'>
            <p className='tools__table-subtitle'>
              {tool?.categories[0]?.fields?.filter(el => el.label === t('toolsRow.labels.comment'))
                ?.length > 0
                ? tool?.categories[0]?.fields?.filter(
                    el => el.label === 'Comment',
                  )[0]?.answers[0]?.length > 0
                  ? tool?.categories[0]?.fields?.filter(
                      el => el.label === 'Comment',
                    )[0]?.answers[0]
                  : '---'
                : '---'}
            </p>
          </div>
          <div className='tools__table-bodyTh'>
            <p className='tools__table-subtitle status'>
              <span className={tool?.calibration_status}>
                {tool?.calibration_status === 'fail'
                  ? t('toolsRow.status.failed')
                  : tool?.calibration_status === 'success'
                    ? t('toolsRow.status.success')
                    : tool?.calibration_status === 'pending'
                      ? t('toolsRow.status.pending')
                      : '---'}
              </span>
            </p>
          </div>
          {/*<div className="tools__table-bodyTh">*/}
          {/*  {*/}
          {/*    tool?.categories[0]?.fields?.filter(el => el.type === 'photo')?.length > 0 ?*/}
          {/*      tool?.categories[0]?.fields?.filter(el => el.type === 'photo')[0]?.photo?.url ?*/}
          {/*        <img className="tools__table-image" src={tool?.categories[0]?.fields?.filter(el => el.type === 'photo')[0]?.photo?.url} alt="test"/>*/}
          {/*        : "N/A" : 'N/A'*/}
          {/*  }*/}
          {/*</div>*/}
        </>
      ) : currentTab == 3 ? (
        <>
          <div className='tools__table-bodyTh'>
            <p className='tools__table-subtitle'>{tool?.equipment_title}</p>
          </div>
          <div className='tools__table-bodyTh'>
            <p className='tools__table-subtitle'>
              {
                tool?.equipment_fields?.filter(
                  el => el.key === 'tool_description',
                )[0]?.value
              }
            </p>
          </div>
          <div className='tools__table-bodyTh'>
            <p className='tools__table-subtitle'>
              {tool?.equipment_fields?.filter(
                el => el.key === 'tool_calibration_period',
              )[0]?.value + ' months'}
            </p>
          </div>
          <div className='tools__table-bodyTh'>
            <p className='tools__table-subtitle'>
              {tool?.categories[0]?.fields?.filter(
                el => el.label === t('toolsRow.labels.calibratedBy'),
              )?.length > 0
                ? tool?.categories[0]?.fields?.filter(
                    el => el.label === t('toolsRow.labels.calibratedBy'),
                  )[0]?.answers[0]?.length > 0
                  ? tool?.categories[0]?.fields?.filter(
                      el => el.label === t('toolsRow.labels.calibratedBy'),
                    )[0]?.answers[0]
                  : '---'
                : '---'}
            </p>
          </div>
          <div className='tools__table-bodyTh'>
            <p className='tools__table-subtitle'>
              {moment(tool?.calibration_due_date)?.format('MM/DD/YYYY')}
            </p>
          </div>
          <div className='tools__table-bodyTh'>
            <p className='tools__table-subtitle'>
              {tool?.categories[0]?.fields?.filter(el => el.label === t('toolsRow.labels.comment'))
                ?.length > 0
                ? tool?.categories[0]?.fields?.filter(
                    el => el.label === 'Comment',
                  )[0]?.answers[0]?.length > 0
                  ? tool?.categories[0]?.fields?.filter(
                      el => el.label === 'Comment',
                    )[0]?.answers[0]
                  : '---'
                : '---'}
            </p>
          </div>
          <div className='tools__table-bodyTh'>
            <p className='tools__table-subtitle status'>
              <span className={tool?.calibration_status}>
                {tool?.calibration_status === 'fail'
                  ? t('toolsRow.status.failed')
                  : tool?.calibration_status === 'success'
                    ? t('toolsRow.status.success')
                    : tool?.calibration_status === 'pending'
                      ? t('toolsRow.status.pending')
                      : '---'}
              </span>
            </p>
          </div>
        </>
            ) : currentTab == 6 ? (
                <>
                <div className='tools__table-bodyTh'>
                  <p className='tools__table-subtitle'>{tool?.type?.title}</p>
                </div>
                <div className='tools__table-bodyTh'>
                  <p className='tools__table-subtitle'>{tool?.title}</p>
                </div>
                <div className='tools__table-bodyTh'>
                  <p className='tools__table-subtitle'>{tool?.fuel_type ? tool?.fuel_type?.name : '---'}</p>
                </div>
                <div className='tools__table-bodyTh'>
                  <p className='tools__table-subtitle'>{tool?.facility?.name}</p>
                </div>
                <div className='tools__table-bodyTh'>
                  <p className='equipment__table-title'>NFC</p>
                      {tool?.beacon_address ? (
                        <p className='equipment__table-subtitle'>
                          <img src='/assets/icons/nfc-active.png' alt='icon' />
                          <img
                            src='/assets/icons/beacon-address.svg'
                            onClick={() => handleUnAssign(tool)}
                            alt='icon'
                          />
                        </p>
                      ) : (
                        <p className='equipment__table-subtitle'>
                          <img src='/assets/icons/nfc-inactive.png' alt='icon'  />
                        </p>
                      )}
                </div>
                <div className='tools__table-bodyTh action'>
                  <ToggleDropdown
                    index={tool?.id}
                    itemId={tool?.id}
                    selectedItem={currentId}
                    setSelectedItem={setCurrentId}
                    >
                      <div className='equipment__table-btn red' onClick={() => handleDelete(tool)}>
                        <Trash color={'#999999'} />
                        {t('equipmentTable.actions.delete')}
                      </div>
                      <div
                  className='equipment__table-btn decom green'
                  onClick={() => {
                    setCurrentId(tool?.id);
                    setActivateModal(true);
                  }}
                    >
                      <Active color={'#999999'}/>
  {t('equipmentTable.actions.unarchive')}
                </div>
                  </ToggleDropdown>
                </div>
              </>
            ) : null}
      </div>
      
      {/* Decommission Reason Row - Full width under the main row for Tools tab */}
      {tool?.decommission_reason && currentTab === 4 && (
        <div className='tools__table-row equipment__reason-row'>
          <div className='equipment__reason-cell' >
            <div className='equipment__reason-message'>
              <DecomissionReason />
              <span>{tool?.decommission_reason}</span>
            </div>
          </div>
        </div>
      )}
  
      {unAssignStatus && currentTab === 6 && <UnAssignModal
        tool={tool}
        setIsOpen={setUnAssignStatus}
        getToolsInitial={()=>{}}
      />}
    </React.Fragment>
  );
};

export default ToolsRow;
